import React, { useState, useEffect, use } from "react";
import {
  Drawer,
  Form,
  Select,
  Button,
  AutoComplete,
  Col,
  Row,
  Input,
  InputNumber,
} from "antd";

import useFetchCommonTypes from "../Hooks/useCommonTypes";

function AddMaterialDrawer({
  onDrawerClose,
  isDrawerOpen,
  title,
  finishSubmit,
  isloading,
  initialValues,
}) {
  const [addEditStockItemForm] = Form.useForm();
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const {
    taxTypes,
    boms,
    setMaterialsForBomSelected,
    getMaterialSelected,
    packingTypes,
    onMaterialSelected,
    measurementTypes,
    selectedMaterial,
    materialTypes,
    error: dataLoadingError,
    isLoading: commonDataIsLoading,
  } = useFetchCommonTypes();

  useEffect(() => {
    addEditStockItemForm.resetFields();
    addEditStockItemForm.setFieldsValue(initialValues);

    const bomId = initialValues?.product?.id ?? null;
    if (bomId) setMaterialsForBomSelected(bomId);
  }, [initialValues, isDrawerOpen]);

  const handleMaterialSelect = (selected, option) => {
    const selectedMaterial = getMaterialSelected(option.key);

    console.log(selectedMaterial);

    addEditStockItemForm.setFieldsValue({
      stockType: {
        code: selectedMaterial?.code,
        id: option.key,
      },
      packingType: {
        id: selectedMaterial?.packingType?.id,
        name: selectedMaterial?.packingType?.name,
      },
    });
  };

  // const handleSearch = (searchText) => {
  //   setOptions(
  //     materialTypes?.map((item) => ({
  //       value: item.name,
  //       key: item.id,
  //       code: item.code,
  //     }))
  //   );

  //   if (!searchText) {
  //     setFilteredOptions(options); // Reset options if search text is empty
  //   } else {
  //     const filtered = options.filter((option) =>
  //       option.value.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //     setFilteredOptions(filtered);
  //   }
  // };
  // const handleBomOnChange = (selected, option) => {
  //   addEditStockItemForm.setFieldValue(["stockType", "name"], "");
  //   addEditStockItemForm.setFieldValue(["stockType", "code"], "");
  //   addEditStockItemForm.setFieldValue(["stockType", "id"], "");
  //   setMaterialsForBomSelected(option.key);
  //   addEditStockItemForm.setFieldValue(["bom", "id"], option.key);
  // };
  const getTaxTypeSelection = (idFieldName) => (
    <Select
      style={{ width: "80px" }}
      onChange={(selected, option) =>
        addEditStockItemForm.setFieldValue(idFieldName, option.key)
      }
    >
      {taxTypes.map((item) => (
        <Select.Option value={item.code} key={item.id}>
          {item.code}
        </Select.Option>
      ))}
    </Select>
  );

  const handleValuesChange = (changedValues, allValues) => {
    const taxValues = allValues.stockReceiptLineTaxes || {};
    const total = Object.values(taxValues).reduce(
      (sum, item) => sum + (Number(item.taxAmount) || 0),
      0
    );
    addEditStockItemForm.setFieldValue("totalDuty", total);
  };

  return (
    <Drawer
      title={title}
      width={560}
      onClose={() => {
        addEditStockItemForm.resetFields();
        onDrawerClose();
      }}
      open={isDrawerOpen}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        name="addEdit-stock"
        layout="vertical"
        requiredMark={false}
        form={addEditStockItemForm}
        initialValues={initialValues}
        onValuesChange={handleValuesChange}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name={["stockType", "code"]} label="HS Code" hidden>
              <Input disabled hidden />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={"id"} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={["stockType", "name"]}
              label="Material*"
              rules={[
                {
                  required: true,
                  message: "Please select a Material!",
                },
              ]}
            >
              {/* <AutoComplete
                options={filteredOptions}
                style={{ width: 200 }}
                onSelect={handleMaterialSelect}
                onSearch={handleSearch}
                placeholder="input here"
              /> */}

              <Select onChange={handleMaterialSelect}>
                {materialTypes &&
                  materialTypes?.map((item) => (
                    <Select.Option value={item.name} key={item.id}>
                      {item.name} ({item.secondaryCode})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            {/* <Form.Item name={"materialId"} hidden> */}
            <Form.Item name={["stockType", "id"]} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={["itemNumber"]}
              label="Item Number"
              rules={[
                {
                  required: true,
                  message: "Please Enter a Item number",
                },
              ]}
            >
              <Input type="number" placeholder="Item Number" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["packingType", "name"]} label="Packing Type*">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["packingType", "id"]} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={"quantity"}
              label="Quantity of Packages"
              rules={[
                {
                  required: true,
                  message: "Please Enter a Number of Units",
                },
              ]}
            >
              <Input type="number" placeholder="Quantity of Packages" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={["measurementType", "name"]}
              label="UOM"
              rules={[
                {
                  required: true,
                  message: "Please Select UOM",
                },
              ]}
            >
              <Select
                onChange={(selected, option) => {
                  addEditStockItemForm.setFieldValue(
                    ["measurementType", "id"],
                    option.key
                  );
                }}
              >
                {measurementTypes?.map((item) => (
                  <Select.Option key={item.id} value={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["measurementType", "id"]} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={"quantityPerItem"} label="Quantity Per Package">
              <Input type="number" placeholder="Quantity Per Unit" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={["netWeight"]}
              label="Net Weight"
              rules={[
                {
                  required: true,
                  message: "Please Enter Net Weight",
                },
              ]}
            >
              <Input type="number" placeholder="Net Weight" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["grossWeight"]} label="Gross Weight">
              <Input type="number" placeholder="Gross Weight" />
            </Form.Item>
          </Col>

          {taxTypes &&
            taxTypes.map((item, index) => (
              <Row gutter={16} key={index}>
                <Col span={24}>
                  <Form.Item
                    name={["stockReceiptLineTaxes", index, "taxType", "id"]}
                    initialValue={item.id}
                    hidden
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["stockReceiptLineTaxes", index, "taxType", "code"]}
                    initialValue={`${item.code}`}
                    hidden
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["stockReceiptLineTaxes", index, "taxAmount"]}
                    initialValue={0}
                    label={`Tax Line ${index + 1}`}
                  >
                    <Input addonBefore={`${item.code}`} addonAfter="LKR" />
                  </Form.Item>
                </Col>
              </Row>
            ))}

          <Col span={24}>
            <Form.Item name={["totalDuty"]} label="Total Liability">
              <Input type="number" readOnly />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["vat"]} label="VAT">
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                max={9999999999}
                defaultValue={0}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div
        style={{
          position: "absolute",
          right: 0,
          bottom: 0,
          width: "100%",
          borderTop: "1px solid #e9e9e9",
          padding: "10px 16px",
          background: "#fff",
          textAlign: "right",
        }}
      >
        <Button onClick={onDrawerClose} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button
          onClick={(value) => {
            addEditStockItemForm
              .validateFields()
              .then((values) => {
                addEditStockItemForm.resetFields();
                initialValues = {};
                finishSubmit(values);
              })
              .catch((error) => console.log(error));
          }}
          type="primary"
          loading={isloading}
        >
          Submit
        </Button>
      </div>
    </Drawer>
  );
}

export default AddMaterialDrawer;
